import {FC, useState} from 'react';
import {Field, Formik, Form} from 'formik';
import * as Yup from 'yup';
import {passwordSchema} from '@/utils/validation';
import {IMAGE_TABLE_ALT, H5, FIELD, PASSWORD, TEXT, END} from '@/utils/constants';
import {Box, Typography, IconButton, InputAdornment} from '@mui/material';
import Button from '@components/Button';
import Input from '@/shared/components/Inputs/Input';
import {ReactComponent as EyeSlashIcon} from '@/assets/icons/eye-slash.svg';
import {ReactComponent as EyeIcon} from '@/assets/icons/eye.svg';
import lockIcon from '@icons/lock.svg';
import {changePasswordModal} from './changePasswordModal.style';

interface ConfirmationModalProps {
	onCloseModal: () => void;
	handleSubmit: (values: any) => void;
}

const validationSchema = () => {
	return Yup.object().shape({
		password: passwordSchema,
		confirmPassword: Yup.string()
			.required('Passwords do not match')
			.test('passwords-match', 'Passwords do not match', function (value) {
				return this.parent.password === value;
			}),
	});
};

const ChangePasswordModalStep2: FC<ConfirmationModalProps> = ({onCloseModal, handleSubmit}) => {
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => setShowPassword((show) => !show);

	return (
		<Box sx={changePasswordModal.content}>
			<Box sx={changePasswordModal.iconWrap}>
				<img src={lockIcon} alt={IMAGE_TABLE_ALT} />
			</Box>
			<Box sx={changePasswordModal.contentWrap}>
				<Typography variant={H5} sx={changePasswordModal.title}>
					New Password
				</Typography>
				<Typography sx={changePasswordModal.description}>Enter and confirm your new password</Typography>
			</Box>
			<Box sx={changePasswordModal.formWrap}>
				<Formik initialValues={{password: ''}} validationSchema={validationSchema()} onSubmit={handleSubmit}>
					{() => (
						<Form>
							<Box sx={changePasswordModal.fieldWrap}>
								<Field
									id={FIELD.password}
									name={FIELD.password}
									placeholder="Enter new password"
									label="New Password"
									component={Input}
									type={showPassword ? TEXT : PASSWORD}
									InputProps={{
										endAdornment: (
											<InputAdornment position={END}>
												<IconButton onClick={handleClickShowPassword} edge={END}>
													{showPassword ? <EyeIcon /> : <EyeSlashIcon />}
												</IconButton>
											</InputAdornment>
										),
									}}
								/>
							</Box>
							<Box sx={{...changePasswordModal.fieldWrap, marginBottom: '32px'}}>
								<Field
									id={FIELD.confirmPassword}
									name={FIELD.confirmPassword}
									placeholder="Confirm new password"
									label="Confirm New Password"
									component={Input}
									type={showPassword ? TEXT : PASSWORD}
									InputProps={{
										endAdornment: (
											<InputAdornment position={END}>
												<IconButton onClick={handleClickShowPassword} edge={END}>
													{showPassword ? <EyeIcon /> : <EyeSlashIcon />}
												</IconButton>
											</InputAdornment>
										),
									}}
								/>
							</Box>
							<Box sx={changePasswordModal.btnWrap}>
								<Button type="submit" sx={changePasswordModal.btn} title="Change Password" disableRipple />
							</Box>
						</Form>
					)}
				</Formik>
			</Box>
		</Box>
	);
};

export default ChangePasswordModalStep2;
